module.exports = __webpack_public_path__ + "static/img/rank_260.616b05c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_260.png
// module id = FkZw
// module chunks = 1